import { render, staticRenderFns } from "./insideIntroduce.vue?vue&type=template&id=155d9298&"
import script from "./insideIntroduce.vue?vue&type=script&lang=js&"
export * from "./insideIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./insideIntroduce.vue?vue&type=style&index=0&id=155d9298&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports